import React, { Component } from 'react'
import './style.scss';
import { TimelineLite, Power2, TweenLite, Back, Power4, TweenMax, Expo } from 'gsap';
import SGButton from '../SGButton';
const data = [{
    id:0,
    name:'Media IQ',
    des:'Situated on the corner of Lavelle Road, in plain view of UB City, this exciting space provides the perfect balance of openness and privacy. Spread out over 24000 sft., the office has one floor for conference rooms, a library, an amphitheater and dining area while a separate floor for workstations ensures maximum productivity.',
    src: 'https://basicagency.com/imager/uploads/case-studies/Fender-Academy/6477/Fender-Academy-Bassbreaker-Cover-Image-01B_974bba97ebdbfe38c7c6078ece6f6a17.jpg 600w, https://basicagency.com/imager/uploads/case-studies/Fender-Academy/6477/Fender-Academy-Bassbreaker-Cover-Image-01B_877de50699a08295026869680339ca47.jpg 940w, https://basicagency.com/imager/uploads/case-studies/Fender-Academy/6477/Fender-Academy-Bassbreaker-Cover-Image-01B_fd86a370f71d27f380250b12fd5f1b14.jpg 1280w, https://basicagency.com/imager/uploads/case-studies/Fender-Academy/6477/Fender-Academy-Bassbreaker-Cover-Image-01B_b0c80ca03ba713639113a0034ddf0313.jpg 2000w',
}, {
    id:1,
    name:'Innov8 Coworking Noida',
    des:'Innov8 enters Bombay with a small space that speaks fun and life. The centre at Boston tower covers a little over 6000 sqft with a cafe in the terrace space. We are slowly evolving the design language of Innov8 as we move forward. The space consists of well balanced private offices, co-working space and nicely proportioned common areas. ',
    src: 'https://basicagency.com/imager/uploads/case-studies/Chrome/4896/Vernor_ChromeFamilia-6163_974bba97ebdbfe38c7c6078ece6f6a17.jpg 600w, https://basicagency.com/imager/uploads/case-studies/Chrome/4896/Vernor_ChromeFamilia-6163_877de50699a08295026869680339ca47.jpg 940w, https://basicagency.com/imager/uploads/case-studies/Chrome/4896/Vernor_ChromeFamilia-6163_fd86a370f71d27f380250b12fd5f1b14.jpg 1280w, https://basicagency.com/imager/uploads/case-studies/Chrome/4896/Vernor_ChromeFamilia-6163_b0c80ca03ba713639113a0034ddf0313.jpg 2000w'
}, {
    id:2,
    name:'Lol',
    des:'something',
    src: 'https://basicagency.com/imager/uploads/case-studies/BB-Dakota/6473/BB-Dakota-Cover-Image-02_974bba97ebdbfe38c7c6078ece6f6a17.jpg 600w, https://basicagency.com/imager/uploads/case-studies/BB-Dakota/6473/BB-Dakota-Cover-Image-02_877de50699a08295026869680339ca47.jpg 940w, https://basicagency.com/imager/uploads/case-studies/BB-Dakota/6473/BB-Dakota-Cover-Image-02_fd86a370f71d27f380250b12fd5f1b14.jpg 1280w, https://basicagency.com/imager/uploads/case-studies/BB-Dakota/6473/BB-Dakota-Cover-Image-02_b0c80ca03ba713639113a0034ddf0313.jpg 2000w'
}]
export default class HomeSlider extends Component {


    constructor(props) {
        super(props);
        this.state = {
            active: 0,
            carouselWidth: 0,
            carouselHeight:0,
            next:1,
            moving: false,
            hoverMoving: false

        }
    }

    tl = new TimelineLite();


    handleResize = () => {
        console.log('hello resize');
        const { tl, carousel } = this;
        const { active, ready, carouselWidth, windowWidth } = this.state;
        const slides = carousel.children;
        const image = carousel.children[0].children[0];
    
        // Only fire if the images have loaded
        if (!ready) return;
        // Only fire if the window width changes, not the window height
        if (windowWidth === window.innerWidth) return;
        // Only fire if the carousel width changes (from Bootstrap's breakpoints)
        if (carouselWidth === carousel.clientWidth) return;
    
        // Move all slides except the active slide outside the visible area of the carousel
        const filteredSlides = Array.from(slides).filter((item, index) => index !== active);
        // Set width equal to the width of the inner carousel div
        const width = carousel.clientWidth;
        // Set height based on aspect ratio of original image dimensions
        //const height = (image.naturalHeight / image.naturalWidth) * width;
        const height = 10;

        tl.set(filteredSlides, {x: width*0.15})
          .eventCallback('onComplete', this.setState({
            carouselHeight: parseInt(height),
            carouselWidth: width,
            windowWidth: window.innerWidth
          }));
      };



      handleLoad = () => {
        console.log('hello load');
        const { tl, carousel, next } = this;
        const { active } = this.state;
        const slides = carousel.children;
        const image = carousel.children[0].children[0];
    
        // Move all slides except the active slide outside the visible area of the carousel
        const filteredSlides = Array.from(slides).filter((item, index) => index !== active);
        // Set width equal to the width of the inner carousel div
        const width = carousel.clientWidth;
        // Set height based on aspect ratio of original image dimensions
       // const height = (image.naturalHeight / image.naturalWidth) * width;
       const height = 10;

        tl.set(filteredSlides, {x: -width*0.15}).to(slides[this.state.next], 0.5, {
            x:width*0.25,
            ease: Power2.easeOut,
        });
       
        tl.set(slides[active], { x:-width*0.15 })


          .eventCallback('onComplete', () => this.setState({
            carouselHeight: parseInt(height),
            carouselWidth: width,
            windowWidth: window.innerWidth,
            ready: true
          }));
      };

    handleNext = () => {
        const { tl, carousel } = this;
        const { active } = this.state;
        const slides = carousel.children;
        const width = carousel.clientWidth;
        const duration = 1;

        if (tl.isActive()) return;

        let current = active;

        this.setState({
            moving:true
        })

        console.log("is moving from "+-width*0.15 - 150+" to "+-width, slides[current]);
        tl.fromTo(slides[current], duration, { x: -width*0.15 - 150 }, {x: -width, ease: Expo.easeInOut, })
            .set(slides[current], {x: width});

        current = (current === (slides.length - 1)) ? 0 : current + 1;
        let next = (current === (slides.length - 1)) ? 0 : current + 1;

        console.log("is moving from "+ width*0.25 - 150 +" to "+-width*0.15, slides[current]);
        
        
        tl.fromTo(slides[current], duration, {x: width*0.25  - 150 }, {x: -width*0.15, opacity:1,  ease: Expo.easeInOut,}, `-=${duration}`).eventCallback('onComplete', () => {
             this.setState({
                 active: current,
                 next,
                 moving:false
                })
             }
         );
         TweenMax.set(slides[next],{
            x: width*0.25
        });
            

        //let next = (current === (slides.length - 1)) ? 0 : current + 1;
        //console.log('checkingnext', next, slides[next]);



        
        console.log("is moving from "+ width +" to "+width*0.25, slides[next]);

        
         

      

        


    }


    handleHover = (e, index) => {
        console.log('Handle hober', index)
        const { tl, carousel } = this;
        const { active } = this.state;
        const slides = carousel.children;
        const width = carousel.clientWidth;
        const duration = 0.8;
       

       
        if (tl.isActive()) return;

        let current = active;
        let next = (current === (slides.length - 1)) ? 0 : current + 1;
        
        if(this.state.next === index) {
            this.setState({
                hoverMoving: true
            })


            TweenLite.to(slides[next], 0.8, {
                x: width*0.25 - 150,
                ease: Power4.easeOut
            });
            TweenLite.to(slides[current],0.8, {
                x:-width*0.15 - 150,
                ease: Power4.easeOut

            })
        }
            

        // else
        //     TweenLite.to(slides[next], 0.5, {
        //         x:width-280,
        //         ease: Power2.easeOut,
        //     })

    }

        
    onMouseLeaveHandle(index) {
        console.log('Handle hober')
        const { tl, carousel, infoContainer } = this;
        const { active } = this.state;
        const slides = carousel.children;
        const width = carousel.clientWidth;
        const duration = 1;
        if (tl.isActive()) return;

        let current = active;
        let next = (current === (slides.length - 1)) ? 0 : current + 1;
        
      
            TweenLite.to(slides[next], 0.5, {
                x: width*0.25,
                ease: Power2.easeOut,
            });
            TweenLite.to(slides[current],0.5, {
                x:-width*0.15
            });

            this.setState({
                hoverMoving: false
            })
          


    }


    sliderClickHandle(e, index) {
        const { active } = this.state;
        const { tl, carousel } = this;
        const slides = carousel.children;
        let next = (active === (slides.length - 1)) ? 0 : active + 1;
        console.log(index, active, next);
        if(index === next)
            this.handleNext();
    }



    componentDidMount () {
        console.log('didmount')
        window.addEventListener('load', this.handleLoad);
        window.addEventListener('resize', this.handleResize);
        const { tl, carousel } = this;
        const slides = carousel.children;
        const width = carousel.clientWidth;
        TweenLite.fromTo(slides[this.state.next], 0.5, {
            x: width
        }, {
            x:width*0.1,
            ease: Power2.easeOut,
        })

        this.setState({
            active: 0,
            carouselWidth: 0,
            carouselHeight:0,
            next:1,

        })




      }
    
      componentWillUnmount () {
          console.log('hello cmunmount');
        window.removeEventListener('load', this.handleLoad);
        window.removeEventListener('resize', this.handleResize);
      }



  render() {
    const { active, carouselHeight, carouselWidth } = this.state;
    //let next = (active === (slides.length - 1)) ? 0 : active + 1;
   
    return (
      <div className="featured-work-carousel" style={{ position:'relative' }}>
        {/* <a onClick={this.handleNext}>mnext</a> */}
        {/* <div className="featured-word--slider--info-wrapper">
            <div className="container">
                <div>
                    <div className="featured-word--slider--info-container">
                    <div className="home-recent--project--details-wrap" style={{ width:'100%', padding:'0 30px' }}>
                        <div ref={ e => this.courDetails = e }>
                            <span className="home-recent--project--details--name">{ this.props.posts[active].node.title }</span>
                            <span className="home-recent--project--details--type">{this.props.posts[active].node.categories[0].name}</span>
                            <span className="home-recent--project--details--para" dangerouslySetInnerHTML={{ __html: this.props.posts[active].node.excerpt }}></span>
                            <div style={{ marginTop:'42px' }}>
                                <SGButton title="SEE THIS POST" to={'/case-study/'+this.props.posts[active].node.slug} />
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div> */}
        <div className="featured-work-carousel__images " className={ this.state.moving ? "featured-work-carousel__images feat--moving"  : this.state.hoverMoving ? "featured-work-carousel__images feat-hoverMoving" : "featured-work-carousel__images" } style={{ position:'relative', overflow:'hidden'}} ref={(carousel) => { this.carousel = carousel; }}>

          {/*
        style={{transform: `matrix(1, 0, 0, 1, ${index === active ? 0 : carouselWidth}, 0)`}}   
        onMouseLeave={() => this.onMouseLeaveHandle(index)}  onMouseEnter={(e) => this.handleHover(e, index)}  */}

            { this.props.posts.map((post, index) => (
                <div onMouseLeave={() => this.onMouseLeaveHandle(index)}  onMouseEnter={(e) => this.handleHover(e, index)}   onClick={(e) => this.sliderClickHandle(e, index)} className={active===index ? "featured-work-carousel__image cur-img-active " : index === this.state.next ? 'featured-work-carousel__image cur-next-slide' : 'featured-work-carousel__image'}  key={'slide-' + index} >
                    <div className="card card--featured-work">
                        <div className="card--featured-work__image">		
                            <img src={post.node.featured_media.source_url} sizes="100vw" style={{ width:'100%' }} alt="" className="layer bg" />
                        </div>
                        
                    </div>
                    <div className="card--featured-work--wrapper">
                        <div className="bottomNext">
                            <div className="rel-pos">
                                <h2>{post.node.title}</h2>
                                <h5>NEXT</h5>
                            </div>
                        </div>
                    </div>



                    <div className="featured-word--slider--info-wrapper" style={{ top:0 }}>
                        <div className="container">
                            <div>
                                <div className="featured-word--slider--info-container" ref={ e => this.infoContainer = e}> 
                                <div className="home-recent--project--details-wrap" style={{ width:'100%', padding:'0 30px' }}>
                                    <div ref={ e => this.courDetails = e }>
                                        <span className="home-recent--project--details--name" dangerouslySetInnerHTML={{__html: post.node.title}}></span>
                                        <span className="home-recent--project--details--type">{post.node.categories[0].name}</span>
                                        <span className="home-recent--project--details--para" dangerouslySetInnerHTML={{ __html: post.node.excerpt.replace(/<\/?[^>]+(>|$)/g, "") }}></span>
                                        <div style={{ marginTop:'42px' }}>
                                            <SGButton title="SEE THIS POST" to={'/case-study/'+post.node.slug} />
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}

            

            

          

        </div>
        
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/HomeSlider/index.js